import { useState } from "react";

export default function NoteCard({ card, onData }) {
  const d = card.data || {};
  const [title, setTitle] = useState(d.title || "");
  const [body, setBody] = useState(d.body || "");

  return (
    <div className="space-y-1">
      <input
        data-testid="note-title-input"
        value={title} onChange={(e) => setTitle(e.target.value)}
        onBlur={() => title !== d.title && onData({ title })}
        placeholder="Note title"
        className="w-full bg-transparent font-display text-base font-bold outline-none placeholder:opacity-40"
      />
      <textarea
        data-testid="note-body-input"
        value={body} onChange={(e) => setBody(e.target.value)}
        onBlur={() => body !== d.body && onData({ body })}
        placeholder="Jot your thoughts... ✦" rows={5}
        className="w-full resize-none bg-transparent text-sm leading-relaxed outline-none placeholder:opacity-40"
      />
      <div className="text-right font-mono text-[10px] opacity-40">{body.length} chars</div>
    </div>
  );
}
